import { type ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router';

import { useAuth } from '@/lib/auth/contexto';
import { Marca } from '@/ui/shell/marca';

/** Tela de troca de senha: é para lá que vai quem está com a troca pendente. */
export const ROTA_SENHA = '/senha';

/**
 * Protege as rotas internas: sem sessão volta ao login guardando para onde a pessoa ia; com a
 * senha definida por outra pessoa, só a tela de troca abre (o servidor recusa o resto com 403).
 */
export function RequerSessao({
  children,
  nomeProduto,
  telaDeSenha = false,
}: {
  children: ReactNode;
  nomeProduto: string;
  /** A própria tela de troca de senha (não redireciona para ela mesma). */
  telaDeSenha?: boolean;
}) {
  const { estado, usuario } = useAuth();
  const local = useLocation();
  if (estado === 'carregando') {
    return (
      <div className="grid min-h-dvh place-items-center" aria-busy="true" aria-label="Abrindo">
        <Marca nome={nomeProduto} compacta className="animate-pulso" />
      </div>
    );
  }
  if (estado === 'anonimo') return <Navigate to="/entrar" replace state={{ de: local.pathname }} />;
  if (usuario?.trocaSenhaPendente && !telaDeSenha) return <Navigate to={ROTA_SENHA} replace />;
  return children;
}
